import { render, staticRenderFns } from "./IconPlusSign.vue?vue&type=template&id=6990c802&"
import script from "./IconPlusSign.vue?vue&type=script&lang=js&"
export * from "./IconPlusSign.vue?vue&type=script&lang=js&"
import style0 from "./IconPlusSign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IconPlusSign.vue"
export default component.exports